<script>
import Layout from "@/views/layouts/default";
import appConfig from "@/app.config";
import StarRating from "vue-star-rating";

export default {
  page: {
    title: "Rating",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    StarRating,
  },
  data() {
    return {
      account: null,
      ratings: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      filter: null
    };
  },
  watch: {
    currentPage() {
      this.getRating();
    },
    filter() {
      if (this.currentPage == 1) {
        this.getRating();
      } else {
        this.currentPage = 1;
      }
    }
  },
  mounted() {
    this.getProfile()
    this.getRating()
  },
  methods: {
    getProfile() {
      this.$axios.get('/v1/logistic_company/auth/profile')
        .then(response => {
          const lc = response.data.data.logistic_company
          this.account = lc
        })
    },
    getRating() {
      this.$axios.get('/v1/logistic_company/auth/rating', {
        params: {
          page: this.currentPage,
          per_page: this.perPage,
          orderby: 'id',
          sort: 'desc',
          rating: this.filter
        }
      })
        .then(response => {
          this.ratings = response.data.data.rows
          this.totalRows = response.data.data.total_data
        })
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-lg-4 pl-0">
        <div class="page-title-box">
          <h4 class="font-size-18">Rating</h4>
        </div>
        <div class="card p-3 pr-4 rounded">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <b-img :src="require('@/assets/images/dashboard/rating.png')" height="60" />
              <p class="text-muted font-weight-normal ml-2 font-size-16">Rating</p>
            </div>
            <div id="rating-desc">
              <p class="font-size-24 font-weight-bolder">{{ account.rating || 0 }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3 ml-0">
      <div class="col-lg-12 pl-0">
        <div class="d-flex">
          <b-button type="button" class="mr-2" :class="{ active: filter === null, 'rating-filter': filter !== null }" @click="filter = null">Semua</b-button>
          <b-button type="button" class="mr-2" :class="{ active: filter === 1, 'rating-filter': filter !== 1 }" @click="filter = 1">
            <div class="d-flex">
              <b-img :src="require('@/assets/images/dashboard/star.png')" height="15" />
              <span class="ml-2">1</span>
            </div>
          </b-button>
          <b-button type="button" class="mr-2" :class="{ active: filter === 2, 'rating-filter': filter !== 2 }" @click="filter = 2">
            <div class="d-flex">
              <b-img :src="require('@/assets/images/dashboard/star.png')" height="15" />
              <span class="ml-2">2</span>
            </div>
          </b-button>
          <b-button type="button" class="mr-2" :class="{ active: filter === 3, 'rating-filter': filter !== 3 }" @click="filter = 3">
            <div class="d-flex">
              <b-img :src="require('@/assets/images/dashboard/star.png')" height="15" />
              <span class="ml-2">3</span>
            </div>
          </b-button>
          <b-button type="button" class="mr-2" :class="{ active: filter === 4, 'rating-filter': filter !== 4 }" @click="filter = 4">
            <div class="d-flex">
              <b-img :src="require('@/assets/images/dashboard/star.png')" height="15" />
              <span class="ml-2">4</span>
            </div>
          </b-button>
          <b-button type="button" class="mr-2" :class="{ active: filter === 5, 'rating-filter': filter !== 5 }" @click="filter = 5">
            <div class="d-flex">
              <b-img :src="require('@/assets/images/dashboard/star.png')" height="15" />
              <span class="ml-2">5</span>
            </div>
          </b-button>
        </div>
      </div>
    </div>

    <div class="row">
      <div v-for="(rating, index) in ratings" :key="index" class="col-lg-12 card rounded px-3 py-2" style="min-height: 114px">
        <div class="d-flex justify-content-between">
          <div class="rating-start d-flex align-items-center">
            <star-rating :increment="0.5" :show-rating="false" :rounded-corners="true" :rating="rating.rating" :star-size="22" :padding="2" :read-only="true"></star-rating>
            <span class="ml-3 pl-3 text-muted border-left">{{ rating.owner | capitalize }}</span>
            <span class="ml-3 pl-3 text-muted border-left">{{ rating.owner_detail.name | capitalize }}</span>
          </div>
          <div class="timestamp-desc">
            <p class="text-muted font-weight-normal font-size-12">
              {{ rating.created_at | date_only }}
            </p>
          </div>
        </div>
        <div class="rating-comment mt-2">
          {{ rating.comment }}
        </div>
      </div>
    </div>

    <div class="row mb-3" v-if="ratings.length > 0">
      <div class="col">
        <div
          class="dataTables_paginate paging_simple_numbers float-right"
        >
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.rating-filter {
  color: #000000 !important;
  background-color: #ffffff !important;
  border-color: #ffffff !important;
}

.active {
  color: #ffffff !important;
  background-color: #f01b3c !important;
  border-color: #f01b3c !important;
}
</style>